import { useQuery } from '@apollo/client';

import {
  GET_PRIOR_YEAR_REVENUES,
  GetPriorYearRevenuesQuery,
  GetPriorYearRevenuesQueryVariables,
} from '@neo.tax/shared';

export const usePriorYearRevenues = ({
  companyId,
}: {
  companyId: string | undefined;
}): {
  priorYearRevenues: GetPriorYearRevenuesQuery['getCompany']['priorYearRevenues'] | null;
  loading: boolean;
} => {
  const { data, loading } = useQuery<GetPriorYearRevenuesQuery, GetPriorYearRevenuesQueryVariables>(
    GET_PRIOR_YEAR_REVENUES,
    companyId ? { variables: { companyId } } : { skip: !companyId },
  );

  return {
    priorYearRevenues: data?.getCompany?.priorYearRevenues || null,
    loading,
  };
};
